export { default, StyledThrobber } from './Throbber';
